import { render, staticRenderFns } from "./NewCourseFaculty.vue?vue&type=template&id=a1c9c76a&"
import script from "./NewCourseFaculty.vue?vue&type=script&lang=js&"
export * from "./NewCourseFaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports